import camera from '../../assets/images/bg_maintenance.webp'
import './maintenance.scss';
import { useTranslation } from 'react-i18next';

const Maintenance: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className='maintenance'>
            <div className="container">
                <h1 className="maintenance__header">{t("maintenance.title")}</h1>
                <div className='img-text'>
                    <img src={camera} alt="" />
                    <div className="maintenance__services">
                        <p className="maintenance__services-text">{t("maintenance.description")}</p>
                        <p className="maintenance__services-text">{t("maintenance.services.title")}
                            <ul className="maintenance__services-ul">
                                <li>- {t("maintenance.services.service1")};</li>
                                <li>- {t("maintenance.services.service2")};</li>
                                <li>- {t("maintenance.services.service3")};</li>
                                <li>- {t("maintenance.services.service4")};</li>
                                <li>- {t("maintenance.services.service5")}.</li>
                            </ul>
                        </p>
                        <p className="maintenance__services-text">{t("maintenance.advantages.advantage1")}</p>
                        <p className="maintenance__services-text">{t("maintenance.advantages.advantage2")}</p>
                        <p className="maintenance__services-text">{t("maintenance.advantages.advantage3")}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Maintenance;